import { AbstractControl, ValidatorFn } from '@angular/forms'

// export function noLeadingTrailingSpaces(): ValidatorFn {
//   return (control: AbstractControl) => {
//     const value: string = control.value ?? ''
//     if (value.length === 0) {
//       return null // Ignore empty value, allow required validator to handle
//     }
//     if (value.startsWith(' ') || value.endsWith(' ')) {
//       return { leadingTrailingSpaces: true }
//     }
//     return null
//   }
// }
export function noLeadingTrailingSpaces(): ValidatorFn {
  return (control: AbstractControl) => {
    const raw = (control.value ?? '').toString()
    const trimmed = raw.trim()
    if (raw.length === 0) {
      return null // let required handle empty
    }

    // Only block pure whitespace
    if (trimmed.length === 0) {
      return { whitespace: true }
    }

    return null
  }
}
